'use strict';

var _extends = require('../../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('prop-types');
var CurrencyDisplay = require('../../../../core/CurrencyDisplay.js');
var Typography = require('../../Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var CurrencyTableCellContent = function CurrencyTableCellContent(_ref) {
  var _ref$wrapperComponent = _ref.wrapperComponent,
      Wrapper = _ref$wrapperComponent === void 0 ? 'div' : _ref$wrapperComponent,
      _ref$wrapperProps = _ref.wrapperProps,
      wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ["wrapperComponent", "wrapperProps", "children"]);

  return React__default["default"].createElement(Wrapper, wrapperProps, React__default["default"].createElement(Typography, _extends["default"]({
    variant: "body1"
  }, props), React__default["default"].createElement(CurrencyDisplay, {
    amountInCents: children
  })));
};

module.exports = CurrencyTableCellContent;
